var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuGeneral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50413 0.554226C13.1964 0.554226 17 4.35781 17 9.05357C17 11.5675 15.9004 13.9083 14.0193 15.5163C13.9294 15.5924 13.7911 15.582 13.7116 15.4955L12.1797 13.7701C12.0933 13.6732 12.1071 13.5315 12.2143 13.445C12.8471 12.9091 13.3623 12.2417 13.7185 11.4775C14.742 9.27831 14.2683 6.68501 12.5705 4.98697C10.3263 2.73934 6.68506 2.73934 4.44103 4.98697C2.04472 7.37636 2.22799 11.2907 4.8041 13.4553C4.90092 13.5383 4.90783 13.6766 4.8283 13.77L3.29302 15.4955C3.21003 15.5888 3.07518 15.5958 2.97491 15.5093C2.05167 14.7174 1.29784 13.7285 0.779167 12.6081C-0.718082 9.36129 -0.00924529 5.54727 2.49083 3.04369C4.02959 1.50493 6.15278 0.554016 8.50398 0.554016L8.50413 0.554226ZM9.32366 8.6353C10.5892 9.2093 10.9074 10.8795 9.91495 11.872C9.13346 12.6535 7.86788 12.6535 7.0864 11.872C6.09745 10.8796 6.41211 9.20946 7.67769 8.6353L8.28283 4.66922C8.32087 4.42025 8.68396 4.42025 8.71851 4.67268L9.32366 8.6353Z",
    fill: "#141320"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuGeneral);
export default __webpack_public_path__ + "static/media/menu-general.fa64f2bddfca978118295d0aab114a3f.svg";
export { ForwardRef as ReactComponent };